module.exports = __webpack_public_path__ + "img/imgNewsTitle.ae762d2e.png";